MultiStepForm[2] = {
  city: false,
  postal_index: false, // Assuming this is postal_code based on step 1? Verify field name if issues persist.
  street: false,
  house_number: false,
  housing_type: false, // Initialize as false
};

// Regex patterns (assuming Spanish addresses)
// Fixed regex_address: Escaped the hyphen '-'
const regex_address = /^[a-záéíóúüñç\s'.\-\dºª]+$/iu; // Allow more chars like numbers, º, ª, escaped hyphen
const regex_postal_index = /^(0[1-9]|[1-4]\d|5[0-2])\d{3}$/; // Spanish postal code format (NNNNN)
const regex_house_number = /^[a-z0-9\sºª/\\-]+$/iu; // Allow numbers, letters, spaces, common chars like /, -, º, ª

const validateAddress = (value) => {
    const trimmedValue = value.trim();
    // Check non-empty, regex match, and basic length
    return trimmedValue !== '' && regex_address.test(trimmedValue) && trimmedValue.length >= 2;
};

const validatePostalIndex = (value) => {
    const trimmedValue = value.replace(/[-\s]/g, ''); // Remove spaces/hyphens before testing
    return trimmedValue !== '' && regex_postal_index.test(trimmedValue);
};

const validateHouseNumber = (value) => {
    const trimmedValue = value.trim();
    return trimmedValue !== '' && regex_house_number.test(trimmedValue);
};


jQuery(document).ready(function ($) {
  // --- Input Field Validation (City, Postal Index, Street, House Number) ---
  $("body").on("keyup", "#form-input-step-2 input", function () {
    const value = $(this).val();
    const name = $(this).data("name");
    // Get label text for better error messages
    const fieldLabel = $(`label[for='${this.id}']`).text().replace('*','').trim();
    const field = fieldLabel || $(this).data("label").replace(/-/g, " ").toLowerCase(); // Fallback
    let success = false;
    let messageOverride = "";

    if (["city", "street"].includes(name)) {
      success = validateAddress(value);
       if (!success && value.trim() !== '') {
           messageOverride = `Por favor, ingresa un ${field} válido.`;
       }
    } else if (name === "postal_index") { // Assuming data-name is postal_index
      success = validatePostalIndex(value);
       if (!success && value.trim() !== '') {
           messageOverride = "Por favor, ingresa un código postal válido (5 dígitos).";
       }
    } else if (name === "house_number") {
      success = validateHouseNumber(value);
       if (!success && value.trim() !== '') {
           messageOverride = `Por favor, ingresa un ${field} válido.`;
       }
    }

    if (success) {
      showSuccess(2, name);
    } else {
      showError(2, name, field, value, messageOverride);
    }
  });

  // --- Radio Button Validation (Housing Type) ---
  $("body").on(
    "change",
    '#form-step-2 input[name="LeadForm[housing_type]"]', // More specific selector
    function () {
      const name = $(this).data("name"); // Should be 'housing_type'
      const field = '¿En dónde vives?'; // Use label text

      // Check if any radio button in the group is checked
      if ($('#form-step-2 input[name="LeadForm[housing_type]"]:checked').length > 0) {
        showSuccess(2, name);
      } else {
        // This case is unlikely to be hit on change, but good for completeness
        const message = `Por favor, selecciona tu ${field}.`;
        showError(2, name, field, '', message);
      }
    }
  );

  // --- Button Handlers ---
  $("body").on("click", "#submit-button-step-2", function (event) {
    event.preventDefault();
    submitForm(2);
  });

  $("body").on("click", "#previous-button-step-2", function (event) {
    event.preventDefault();
    showPreviousForm(1);
  });

  $("body").on("click", "#mobile-previous-button-step-2", function (event) {
    event.preventDefault();
    showPreviousForm(1);
  });

  $("body").on("click", "#sidebar-step-1", function (event) {
    event.preventDefault();
    showPreviousForm(1, "sidebar");
  });
});
